<script setup>
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import Tr from '@/i18n/translation';
import ChevronIcon from "@/components/CustomIcons/ChevronIcon.vue";
import GlobeIcon from "@/components/CustomIcons/GlobeIcon.vue";

const props = defineProps({
  direction: {
    type: String,
    default: 'up',
    validator: (value) => ['up', 'down'].includes(value),
  },
});

const { t, locale } = useI18n();

const { supportedLocales } = Tr;

const router = useRouter();

const switchLanguage = async (newLocale) => {
  if (newLocale === locale.value) {
    return;
  }
  await Tr.switchLanguage(newLocale);
  try {
    await router.replace({ params: { locale: newLocale } });
  } catch (e) {
    console.log(e);
    await router.push('/');
  }
  window.location.reload();
};
</script>
<template>
  <Menu as="div" class="relative inline-block text-left" v-slot="{ open }">
    <MenuButton class="flex items-center gap-1 text-primary text-sm hover:opacity-80 transition outline-none">
      <GlobeIcon />
      <span>{{ t(`locale.${locale}`) }}</span>
      <ChevronIcon :rotate="open" />
    </MenuButton>

    <transition leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95" enter-active-class="transition ease-out duration-100"
      enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100">
      <MenuItems
        class="absolute right-0 w-24 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50 text-black flex flex-col py-1"
        :class="{
          'bottom-full mb-2': direction === 'up',
          'top-full mt-2': direction === 'down'
        }">
        <MenuItem v-for="sLocale in supportedLocales" :key="`locale-${sLocale}`" as="template" v-slot="{ active }">
        <button @click="switchLanguage(sLocale)" class="px-3 py-1.5 text-sm text-left w-full" :class="[
          active ? 'bg-gray-100' : '',
          sLocale === locale ? 'font-bold' : ''
        ]">
          {{ t(`locale.${sLocale}`) }}
        </button>
        </MenuItem>
      </MenuItems>
    </transition>
  </Menu>
</template>
